import React from "react"

type ErrorTextProps = {
    errors: string|string[]|null
}

export function ErrorText({errors}: ErrorTextProps) {

    if (errors == null) return null

    if(typeof errors === "string"){
        errors = [errors]
    }

    if(errors.length > 0){
        return (
            <div>
                {errors.map((error) => (
                    <p key={error} className="text-center text-red">{error}</p>
                ))}
            </div>
        )
    }


    return null
}